import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

function useManageQuiz() {
  const history = useHistory();
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function addQuiz(data) {
    return privateFetch.post(`/v1/admin/quiz`, data);
  }

  function updateQuiz(quizID, data) {
    return privateFetch.put(`/v1/admin/quiz/${quizID}`, data);
  }

  function deleteQuiz(quizID) {
    return privateFetch.delete(`/v1/admin/quiz/${quizID}`);
  }

  function manageQuiz(data = {}) {
    if (data?.id) {
      return updateQuiz(data.id, data);
    }
    if (data?.type === 'DELETE') {
      return deleteQuiz(data.topicID);
    }

    return addQuiz(data);
  }

  return useMutation(manageQuiz, {
    onSuccess() {
      //history.goBack(); //as per older table design
    },
    onSettled() {
      //queryClient.invalidateQueries('quiz-lists'); //as per older table design
      queryClient.invalidateQueries('chapters');
    },
  });
}

export default useManageQuiz;
